import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" id="explore-categories">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索你的韩国之旅
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            六大板块，全方位覆盖韩国旅行所需的一切
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute top-4 left-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/90 backdrop-blur-sm">
                    <i className={`${cat.icon} text-lg text-primary-500`}></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-200/70 px-2.5 py-1 rounded-full whitespace-nowrap">
                    {cat.articleCount}篇攻略
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}